import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PipeModule } from '@shared/pipe/pipe.module';


interface DialogData {
  videoId: string;
}

@Component({
  selector: 'app-youtube-dialog',
  imports: [MatDialogModule, PipeModule],
  templateUrl: './youtube-dialog.component.html',
  styleUrl: './youtube-dialog.component.scss'
})
export class YoutubeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<YoutubeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }
}
